import { User } from "../../@types/users";

type UserResponse = {
  id: string;
  firstName: string;
  lastName: string;
  isDriver?: boolean;
  username?: string | null;
  lastLoginTime?: string | Date | null;
  lastActivityTime?: string | Date | null;
  role: {
    id: string;
    name: string;
  };
};

export const formatUser = (user: UserResponse): User => {
  return {
    id: String(user.id),
    firstName: user.firstName,
    lastName: user.lastName,
    isDriver: Boolean(user.isDriver),
    username: user.username || null,
    lastLoginTime: user.lastLoginTime ? new Date(user.lastLoginTime) : null,
    lastActivityTime: user.lastActivityTime ? new Date(user.lastActivityTime) : null,
    role: {
      id: String(user.role.id),
      name: user.role.name,
    },
  };
};

export const formatGetAllUsers = (response: UserResponse[]): User[] => {
  return response.map(formatUser);
};
